// extracted by mini-css-extract-plugin
module.exports = {"form":"BackInStockForm_form__Td4iz"};